import React from "react";
import "./carteHorsConnexion.scss";

// Carte centrée des pages ouvertes depuis un lien reçu par e-mail (activation du compte,
// invitation) : logo, titre de la page, puis le contenu propre à chaque état.
const CarteHorsConnexion = ({ titre, children }) => (
  <div className="row">
    <div className="col-12 col-md-8 col-lg-6 m-auto">
      <div className="carte-hors-connexion">
        <img
          src="/images/logo-small.svg"
          alt=""
          className="carte-hors-connexion__logo"
        />
        <h1 className="carte-hors-connexion__titre">{titre}</h1>
        {children}
      </div>
    </div>
  </div>
);

// Lien vers l'espace client en rechargement complet : la session est relue, et un compte
// tout juste activé n'est plus renvoyé vers l'écran « Activez votre compte ».
export const LienEspaceClient = ({ libelle = "Accéder à mon espace client" }) => (
  <a href="/" className="carte-hors-connexion__action">
    {libelle}
  </a>
);

export default CarteHorsConnexion;
